import React, { useContext, useState } from 'react'
import { InitializeContext } from '../../../App';
import ServicesCard from './ServicesCard';
import { servicesData } from '../../../data/servicesData';
import { MdExpandMore } from 'react-icons/md';

const Fade = require("react-reveal/Fade");

const initialCardsToShow = 6;

export default function Services() {
          const { theme } = useContext(InitializeContext);
          const [cardsToShow, setCardsToShow] = useState(initialCardsToShow);

          return (
                    <section id={'services'} className={`md:py-20 pb-16 md:pb-5 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'}`}>
                              <div className='text-center flex-col justify-center items-center md:flex'>
                                        <small className="text-sm mb-3">
                                                  SERVICES.
                                        </small>
                                        <h1 className="font-bestWishes text-2xl md:text-3xl font-bold leading-tight">
                                                  What I Offer
                                        </h1>
                              </div>

                              <div className="hero">
                                        <div className="hero-content -mt-5">
                                                  <Fade bottom distance="20px">
                                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 w-full mx-auto mt-5 md:mt-10">
                                                                      {
                                                                                servicesData.slice(0, cardsToShow).map(item => (
                                                                                          <ServicesCard
                                                                                                    key={item.id}
                                                                                                    image={item.image}
                                                                                                    title={item.title}
                                                                                                    desc={item.desc}
                                                                                          />
                                                                                ))
                                                                      }
                                                            </div>
                                                  </Fade>
                                        </div>
                              </div>
                              {
                                        cardsToShow < servicesData.length && (
                                                  <div className="flex justify-center items-center mt-3 md:mt-5">
                                                            <button onClick={() => setCardsToShow((prev) => prev + 3)} className={`flex items-center gap-1 border cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                                                                      See More <MdExpandMore size={22} />
                                                            </button>
                                                  </div>
                                        )
                              }
                    </section>
          )
}
